import { isDesktop } from "~/utils/media";

export default defineNuxtRouteMiddleware(() => {
  if (isDesktop.value) {
    return abortNavigation();
  }
});
